import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import request from "../../../../tools/request";
// The shared Dialog pins its paper to `max-height: calc(100% - 64px) !important`,
// which clips the Stripe checkout iframe. MUI's Dialog is used directly here so
// `scroll="body"` can let the dialog grow and scroll instead.
import {
    CircularProgress,
    Dialog,
    DialogContent,
    IconButton,
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import "./stripeCheckoutBlade.scss";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const StripeCheckoutBlade = (props) => {
    const [clientSecret, setClientSecret] = useState(null);
    // `source` flags where the checkout was started from: "onboarding" (self-signup
    // deep link) shows the onboarding confirmation modal on return; anything else
    // (e.g. an in-app plan upgrade) returns without it. Defaults to "upgrade".
    const {priceId,open,onClose, disableCall, source = "upgrade", planName} =  props

    const loadClientSecret =  () => {
        const user = JSON.parse(localStorage.getItem("user"));
        request('stripe/write/createPaymentSession', 'POST',     {
            priceId:priceId,
            returnUrl:window.location.origin+`/settings/showConfirmation/${source}`,
            userId:user.userId
        }).then((response) =>{
            setClientSecret(response.sessionCode);
        });
    };

    useEffect(() =>  {
        if(!!priceId && !disableCall){
            loadClientSecret();
        }
    }, [priceId, disableCall, source]);

    return (


    <Dialog
        open={open}
        fullWidth={true}
        // Stripe's checkout collapses to a single stacked column below ~1000px, which
        // looks far worse inside a wide dialog. "lg" keeps the two-column layout.
        maxWidth="lg"
        // The checkout form is taller than the viewport: let the dialog grow to the
        // iframe's full height and scroll the whole thing instead of clipping it.
        scroll="body"
        onClose={onClose}
        disableEscapeKeyDown
        PaperProps={{ className: 'sc-dialog-paper' }}
    >
        <DialogContent className='sc-content'>
            <IconButton className='sc-close' aria-label="Close" onClick={onClose}>
                <CloseIcon fontSize="small" />
            </IconButton>

            <h2 className='sc-title'>
                {planName ? `Get started with ${planName}` : 'Payment & billing'}
            </h2>
            <p className='sc-subtitle'>
                Set up your plan. No charge until you confirm.
            </p>

            {clientSecret ? (
                <div className='sc-checkout'>
                    <EmbeddedCheckoutProvider
                        stripe={stripePromise}
                        options={{ clientSecret }}
                    >
                        <EmbeddedCheckout />
                    </EmbeddedCheckoutProvider>
                </div>
            ) : (
                <div className='sc-loading'>
                    <CircularProgress size={28} color='inherit' />
                </div>
            )}
        </DialogContent>
    </Dialog>
    );
};

export default StripeCheckoutBlade;
